<template>
  <div>
    <el-row id="menu_type">
      <el-col :span="24">
        <el-menu
          class="el-menu-vertical-demo"
          :unique-opened="true"
          @open="handleOpen"
          @select="handleSelect"
          @close="handleClose"
        >
          <el-menu-item index="1">
            <i class="el-icon-user-solid"></i>
            <template #title>账户信息</template>
          </el-menu-item>
          <el-menu-item index="2">
            <i class="el-icon-postcard"></i>
            <template #title>充值记录</template>
          </el-menu-item>
          <el-menu-item index="3">
            <i class="el-icon-key"></i>
            <template #title>重置密码</template>
          </el-menu-item>
          <el-menu-item index="5">
            <i class="el-icon-collection"></i>
            <template #title>我的收藏</template>
          </el-menu-item>
          <el-menu-item index="6">
            <i class="el-icon-notebook-2"></i>
            <template #title>历史记录</template>
          </el-menu-item>
          <el-menu-item index="4">
            <i class="el-icon-back"></i>
            <template #title>返回阅读</template>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    handleOpen (key, keyPath) {
      // alert(key)
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath)
    },
    handleSelect (key, keyPath) {
      switch (key) {
        case '1':
          this.$router.push('/userCenter/info').catch(() => {})
          break
        case '2':
          this.$router.push('/userCenter/shopRecords').catch(() => {})
          break
        case '3':
          this.$router.push('/userCenter/resetPasswd').catch(() => {})
          break
        case '4':
          this.$router.push('/imgList/barrel').catch(() => {})
          break
        case '5':
          this.$router.push('/userCenter/collection').catch(() => {})
          break
        case '6':
          this.$router.push('/userCenter/history').catch(() => {})
          break
        default:
          alert('用户菜单没有此选项, 请重新选择')
          break
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tree_one {
  font-size: 20px;
  font-weight: 700;
}
#menu_type i {
  color: #fff;
  font-size: 24px;
}
#menu_type {
  width: 220px;
}
#menu_type :deep(.el-menu-item) {
  font-size: 20px;
  color: #fff;
  font-weight: 700;
}
#menu_type :deep(.el-menu-item:hover) {
  background-color: transparent;
}
#menu_type :deep(.el-menu-item:focus) {
  background-color: transparent;
}
#menu_type :deep(.el-menu) {
  background-color: transparent;
  border-right-color: transparent;
}
</style>
